<template>
  <div class="relative">
    <qrcode-stream @decode="onDecode"></qrcode-stream>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue3-qrcode-reader';

export default {
  components: { QrcodeStream },
  data() {
    return {
      qr: null,
      errorMessage: '',
    };
  },
  methods: {
    onDecode(data) {
      if (this.isValidQRCode(data)) {
        this.$emit('decoded', data);
      } else {
        this.errorMessage = 'Invalid QR code detected. Please try again.';
      }
    },
    isValidQRCode(data) {
      // Implement your validation logic here
      // For example, check if the data matches a specific pattern or length
      const qrPattern = /^[A-Za-z0-9]{10,}$/; // Example pattern: alphanumeric and at least 10 characters
      return qrPattern.test(data);
    }
  }
};
</script>

<style scoped></style>
